import { h } from "preact";

import IconProps from "./IconProps";

function IconSelectParent({
    class: cssClass
}: IconProps) {
    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 4a1 1 0 0 1 .897-.995L4 3h2v1H4v2H3V4zM8.732 6.232a.5.5 0 0 1 .707 0l1.415 1.415a.5.5 0 0 1 0 .707L9.439 9.768a.5.5 0 1 1-.707-.707l.561-.56H5.5a.5.5 0 0 1 0-1h3.793l-.56-.561a.5.5 0 0 1 0-.708zM3 10v2l.005.102a1 1 0 0 0 .892.893L4 13h2v-1H4v-2H3zM10 13h2l.102-.005a1 1 0 0 0 .893-.893L13 12v-2h-1v2h-2v1zM13 6h-1V4h-2V3h2l.102.005A1 1 0 0 1 13 4v2z" fill="#fff"/>
        </svg>
    );
}

export default IconSelectParent;
